module.exports = __webpack_public_path__ + "img/pinterest.d1226e66.svg";